import { createSelector } from "@reduxjs/toolkit";

import { selectSalesLoading } from "store/slices/sales";
import { selectTokensLoading } from "store/slices/tokens";

export const selectLoading = createSelector(
  [selectSalesLoading, selectTokensLoading],
  (salesLoading, tokensLoading) => salesLoading || tokensLoading
);
